import React, { useEffect, useState } from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const EditableCell = _ref => {
  let {
    isEditing,
    onEditModeChange,
    viewComponent,
    editComponent = () => /*#__PURE__*/_jsx(_Fragment, {
      children: "no editComponent Provided"
    }),
    value,
    disabled
  } = _ref;
  const [isInputVisible, setIsInputVisible] = useState(isEditing);
  useEffect(() => {
    setIsInputVisible(isEditing);
  }, [isEditing]);
  const setEditMode = editing => {
    if (onEditModeChange) {
      onEditModeChange(editing);
    } else {
      setIsInputVisible(editing);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    onClick: () => {
      if (!isInputVisible) {
        setEditMode(!isInputVisible);
      }
    },
    style: {
      height: '100%',
      cursor: disabled ? 'default' : 'pointer',
      padding: '5px'
    },
    children: isInputVisible ? disabled ? viewComponent : editComponent : viewComponent ? viewComponent : value
  });
};